import { Toast } from "@heroui/react";
import { appToastQueue } from "@/lib/ui/app-toast";

/** 根 Toast：默认顶部 placement（业务 / 复制 / undo 共用同一队列）。 */
export const ToastProvider = () => {
  return <Toast.Provider placement="top" queue={appToastQueue} />;
};
